/**
 * CameraTrouble — why the camera did not open, and what to do about it.
 *
 * "Allow camera access and try again" is useless on a phone, where the
 * permission is usually needed from the operating system as well as from the
 * browser. The steps come from `lib/cameraAccess.js` and name both.
 */
import React from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const CameraTrouble = ({ error, steps = [], onRetry }) => {
  if (!error) return null;
  return (
    <div className="rounded-lg border border-rose-900/60 bg-rose-950/40 p-4"
         data-testid="broadcast-error">
      <p className="flex items-start gap-2 text-sm text-rose-200">
        <AlertTriangle className="h-4 w-4 shrink-0 mt-0.5" />
        <span>{error}</span>
      </p>
      {steps.length > 0 && (
        <ol className="mt-2.5 ml-6 list-decimal space-y-1 text-sm text-rose-200/80"
            data-testid="camera-fix-steps">
          {steps.map((s) => <li key={s}>{s}</li>)}
        </ol>
      )}
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry}
                className="mt-3 border-rose-800 bg-transparent text-rose-100 hover:bg-rose-900/40"
                data-testid="camera-retry-btn">
          <RotateCcw className="h-3.5 w-3.5 mr-1.5" />Try the camera again
        </Button>
      )}
    </div>
  );
};

export default CameraTrouble;
